import styled from 'styled-components';
import { Progress, Buffer } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';

interface Props {
  src: string;
  uploadProgress: number;
}

const NUMBER_OF_UPLOAD_PHASES = 4;

const ImageWithProgress = ({ src, uploadProgress }: Props) => {
  const { translate } = useTranslate();

  const progress = uploadProgress / NUMBER_OF_UPLOAD_PHASES;

  const renderProgressOrBuffer = () => {
    switch (progress) {
      case 0:
        return <Buffer noCornerRadius />;
      case 100:
        return <Buffer color="brand" noCornerRadius />;
      default:
        return <Progress width={progress} color="brand" noCornerRadius />;
    }
  };

  return (
    <StyledImageContainer>
      <StyledImage src={src} alt={translate('IMAGE_WITH_PROGRESS.IMG_ALT')} />
      <StyledProgressBarContainer>
        {renderProgressOrBuffer()}
      </StyledProgressBarContainer>
    </StyledImageContainer>
  );
};

export default ImageWithProgress;

export const StyledImageContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const StyledImage = styled.img`
  width: 100%;
  opacity: 50%;
`;

const StyledProgressBarContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  // design-system Buffer
  bottom: 20px;

  ${StyledImageContainer} > & {
    bottom: 0;
  }
`;
